import getters from '@/store/modules/getters'
import mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

mutations.SNSLIST = function (state, payload) {
  state.sns_list = payload
}
mutations.USERLIST = function (state, payload) {
  state.user_list = payload
}
mutations.POST_ROWS = function (state, payload) {
  payload.forEach(el => {
    if (!SysUtils.isEmpty(el.image_fid)) el.image_fid = el.image_fid.split(',')
    if (!SysUtils.isEmpty(el.image_fid)) el.mimetype = el.mimetype.split(',')
    if (!SysUtils.isEmpty(el.sns_name)) el.sns_name = el.sns_name.split(',')
    if (!SysUtils.isEmpty(el.file_path)) el.file_path = el.file_path.split(',')
  })
  if (!SysUtils.isEmpty(payload)) {
    let data = payload[0]
    if ((data.approved === 3 || (data.approved === null || data.published === null)) && data.published === 0) state.rows.draft = payload
    else if (data.approved === 1 && data.published === 2) state.rows.failed = payload
    else if (data.approved === 2 && data.published === 0) state.rows.rejected = payload
    else if (data.approved === 0 && data.published === 0) state.rows.pending = payload
    else if (data.approved === 1 && data.published === 1) state.rows.published = payload
    else if (data.approved === 1 && data.published === 0) state.rows.approved = payload
  }
}
mutations.GET_EDIT_DATA = function (state, payload) {
  payload.files.forEach(el => {
    el.url = window.API_URL + 'download.api?api=AppFileService.getData&id=' + el.id
  })
  state.row = payload
}

const state = {
  rows: {
    failed: [],
    rejected: [],
    pending: [],
    approved: [],
    published: [],
    draft: []
  },
  row: {
    id: null,
    social_media: [],
    file: []
  },
  sns_list: [],
  user_list: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        sns_list: { api: 'M0101SNSAccountService.getSnsNameList' },
        user_list: { api: 'M0101SNSAccountService.getUserNameList' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('SNSLIST', data.sns_list.output)
        commit('USERLIST', data.user_list.output)
      })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0102SNSContent search')
    return client.postData({ data: { search: { api: 'M0102SNSPostMasterService.searchPost', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
        }
        commit('POST_ROWS', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0102SNSContent add')
    commit('EDIT',
      {
        id: null,
        files: [],
        social_media: []
      }
    )
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0102SNSContent cancel')
    commit('EDIT', {id: null, files: [], social_media: []})
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0102SNSContent edit')
    return client.postData({ data: { find: { api: 'M0102SNSPostMasterService.getPost', input: {id: id} } } })
      .then((data) => {
        commit('GET_EDIT_DATA', data.find.output)
      })
  },
  delete: ({ commit, state }, id) => {
    console.debug('called M0102SNSContent delete')
    return client.postData({ data: { delete: { api: 'M0102SNSPostMasterService.deletePost', input: {id: id} } } })
      .then((data) => {
        commit('EDIT', {id: null, files: [], social_media: []})
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0102SNSContent save')
    return client.postData({ data: { save: { api: 'M0102SNSPostMasterService.savePost', input: row } } })
      .then((data) => {
        commit('EDIT', {id: null, files: [], social_media: []})
      })
  },
  doApproveOrReject: ({ commit, state }, data) => {
    console.debug('called M0102SNSContent grantPost')
    return client.postData({ data: { grantPost: { api: 'M0103SNSPostDetailService.grantPost', input: data } } })
      .then((data) => {
        commit('POST_ROWS', data.grantPost.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
